module.exports = __webpack_public_path__ + "static/media/calendar-bg.2af14e8f.jpg";